// @flow
import type {GetDisableIdsList} from '../typedef';

export const getDisabledIdsList: GetDisableIdsList = data => {
    return data.reduce((acc, treeItem) => {
        const {children, id, disabled} = treeItem;

        const checkItem = disabled ? [id] : [];

        if (children) {
            return acc.concat(checkItem, getDisabledIdsList(children));
        }

        return acc.concat(checkItem);
    }, []);
};
